<template>
	<v-container 
		fluid
		fill-height
		class="buy-token-container"
	>
		<v-layout 
			align-center 
			justify-center
		>
			<v-flex
				xs4
			>
				<v-card
					flat
					dark
					color="#00001B"
					elevation="20"
				>
					<v-card-title>
						<h1 v-if="!hasBought">
							Buy Token
						</h1>
						<h1 v-else>
							Thank You
						</h1>
					</v-card-title>
         
					<v-container v-if="!hasBought" grid-list-xs>
						<h3>Please, enter the amount of tokens you want to buy</h3>
						<v-layout row wrap>
							<v-flex md5> 
								<v-text-field 
									v-model="amount"
									color="warning" 
									prepend-icon="fas fa-coins"
								/>
							</v-flex>

							<v-layout 
								column 
								wrap
								align-center
								justify-center
							>
								<v-icon>fas fa-arrow-right</v-icon>
							</v-layout>

							<v-layout row wrap align-center>
								<v-flex>
									<v-icon>fab fa-ethereum</v-icon>
									<h2>{{ ethAmount.toFixed(8) }}</h2>
								</v-flex>

								<v-flex>
									<v-icon>fas fa-euro-sign</v-icon>
									<h2>{{ eurAmount.toFixed(4) }}</h2>
								</v-flex>
							</v-layout>
						</v-layout>
						
						<h5>The fee for this operation is equal to 0.2%</h5>
					</v-container>
					<v-container v-else grid-list-xs>
						<h3>The transaction is being processed, you will recive a notification as soon as the transction will be confirmed!</h3>
					</v-container>
					<v-card-actions>
						<v-spacer />
						<v-btn 
							flat
							color="error" 
							@click="showBuyToken (false)"
						>
							Dismiss
						</v-btn>
						<v-btn 
							v-if="!hasBought"
							flat
							color="success" 
							@click="setBought ()"
						>
							Buy
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapMutations, 
	mapActions, 
	mapState } from 'vuex'

export default {
	data () {
		return {
			hasBought: false,
			amount: null,
			feeValue: 0.2,
			re20Value: 0.001
		}
	},

	computed: {
		...mapState ({
			ethValue: state => state.ethereum.ethValue,
		}),

		ethAmount () {
			return (this.amount * this.re20Value) + (((this.amount * this.re20Value) * this.feeValue) / 100 )
		},

		eurAmount () {
			return (this.ethValue * this.ethAmount)
		}
	},

	watch: {

	},

	methods: {
		...mapMutations (['showBuyToken', 'incrementToken', 'decrementToken']),
		...mapActions (['getEthereumValue','buyRE20']),

		setBought () {
			this.buyRE20 (this.amount)
			this.hasBought = true
		}

	},

	created () {
		this.getEthereumValue ()
		console.log (this.ethValue)
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.buy-token-container {
	background-color:rgba(36, 41, 68, 0.63);
	position: absolute;
	z-index: 10;
	top: 0px;
}

</style>
